
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'

@Component({
  components: {},
  asyncData(ctx) {
    if (ctx.route.name === 'protocol') {
      ctx.redirect({ name: 'protocol-service' })
    }
  }
})
export default class PageView extends Vue {
  tabsList: {
    key: string
    name: string
  }[] = [
    {
      key: 'protocol-service',
      name: '用户协议'
    },
    {
      key: 'protocol-privacy',
      name: '隐私政策'
    },
    {
      key: 'protocol-feedback',
      name: '侵权反馈'
    },
    {
      key: 'protocol-contact',
      name: '联系我们'
    }
  ]

  current: string = 'protocol-service'

  get hideLeft(): boolean {
    return this.$route.name === 'protocol-guild'
  }

  changeTab(idx: string) {
    if (this.current === idx) return

    this.current = idx

    document.documentElement.scrollTo({ top: 0 })

    this.$router.replace({ name: idx })
  }

  // 同步当前tabs的指示
  initTab() {
    const i = this.tabsList.find(tab => tab.key === this.$route.name)

    if (i) this.current = i.key
  }

  created(): void {
    this.initTab()
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
